export const ADD_FAVOURITE_CURRENCY = 'ADD_FAVOURITE_CURRENCY'
export const SET_FAVOURITE_CURRENCY_LIST = 'SET_FAVOURITE_CURRENCY_LIST'
